import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderHistorySnapshot } from "../websiteBuilderEditorAction";
import { isWebsiteBuilderContainer, TWebsiteBuilderContainer, TWebsiteBuilderContainerData } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { IWebsiteBuilderGeneralTraversalNode } from "./generalTraversal";

type TContainerTraversalNode = TWebsiteBuilderContainer | IWebsiteBuilderGeneralTraversalNode;
type TContainerTraversalUpdates = Partial<TWebsiteBuilderContainerData>;

function applyUpdates<T extends TWebsiteBuilderContainerData>(container: T, updates: TContainerTraversalUpdates): T {
  return {
    ...container,
    ...updates,
  };
}

export function containerTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  id: string,
  updates: TContainerTraversalUpdates,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: TContainerTraversalNode): TContainerTraversalNode {
    if (isWebsiteBuilderContainer(node)) {
      if (node.id === id) {
        return {
          ...node,
          container: applyUpdates(node.container, updates),
        };
      } else {
        return node;
      }
    } else {
      if (!node.children) {
        return node;
      } else {
        return {
          ...node,
          children: node.children.map(traverse),
        };
      }
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}
